// Traduções do painel de seleção — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'form.selectionTable.mode.aria': 'Modo de acesso',
    'form.selectionTable.mode.all': 'Acesso a todos',
    'form.selectionTable.mode.subset': 'Acesso somente aos itens selecionados',
    'form.selectionTable.allNotice':
      'Este usuário terá acesso a todos os itens desta área, inclusive aos que forem cadastrados depois.',
    'form.selectionTable.selectPageAria': 'Selecionar os itens desta página',
    'form.selectionTable.selectRowAria': 'Selecionar {{item}}',
    'form.selectionTable.pageScopeHint': 'A caixa do cabeçalho marca apenas os itens desta página.',
    'form.selectionTable.selectedCount': 'Selecionados {{count}}',
    'form.selectionTable.clear': 'Limpar seleção',
    'form.selectionTable.showAll': 'Ver todos os {{count}}',
    'form.selectionTable.showLess': 'Ver menos',
    'form.selectionTable.remove': 'Remover {{item}} da seleção',
    'form.selectionTable.noResults': 'Nenhum resultado para esta busca.',
    'form.selectionTable.allCategories': 'Todas as categorias',
  },
  en: {
    'form.selectionTable.mode.aria': 'Access mode',
    'form.selectionTable.mode.all': 'Access to all',
    'form.selectionTable.mode.subset': 'Access only to the selected items',
    'form.selectionTable.allNotice':
      'This user will access every item in this area, including the ones registered later.',
    'form.selectionTable.selectPageAria': 'Select the items on this page',
    'form.selectionTable.selectRowAria': 'Select {{item}}',
    'form.selectionTable.pageScopeHint': 'The header box marks only the items on this page.',
    'form.selectionTable.selectedCount': 'Selected {{count}}',
    'form.selectionTable.clear': 'Clear selection',
    'form.selectionTable.showAll': 'Show all {{count}}',
    'form.selectionTable.showLess': 'Show less',
    'form.selectionTable.remove': 'Remove {{item}} from the selection',
    'form.selectionTable.noResults': 'No results for this search.',
    'form.selectionTable.allCategories': 'All categories',
  },
  es: {
    'form.selectionTable.mode.aria': 'Modo de acceso',
    'form.selectionTable.mode.all': 'Acceso a todos',
    'form.selectionTable.mode.subset': 'Acceso solo a los elementos seleccionados',
    'form.selectionTable.allNotice':
      'Este usuario accederá a todos los elementos de esta área, incluidos los registrados después.',
    'form.selectionTable.selectPageAria': 'Seleccionar los elementos de esta página',
    'form.selectionTable.selectRowAria': 'Seleccionar {{item}}',
    'form.selectionTable.pageScopeHint':
      'La casilla del encabezado marca solo los elementos de esta página.',
    'form.selectionTable.selectedCount': 'Seleccionados {{count}}',
    'form.selectionTable.clear': 'Limpiar selección',
    'form.selectionTable.showAll': 'Ver todos los {{count}}',
    'form.selectionTable.showLess': 'Ver menos',
    'form.selectionTable.remove': 'Quitar {{item}} de la selección',
    'form.selectionTable.noResults': 'Ningún resultado para esta búsqueda.',
    'form.selectionTable.allCategories': 'Todas las categorías',
  },
}
